<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-amber">
    <mat-icon>info</mat-icon>
  </div>
  <h2>{{ 'ADMIN.OUT_OF_DATE' | translate }}</h2>
</div>
<div mat-dialog-content>
  <p class="m-0">{{ 'ADMIN.UPDATE_THE_APP' | translate }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="document.location.reload()">
    <mat-icon>refresh</mat-icon>
    {{ 'ADMIN.REFRESH' | translate }}
  </button>
</div>
